import Styled from 'styled-components';



export const Container = Styled.div`
display:flex;
height: 100vh;
justify-content: center;
//background-color: ${props => props.theme.colors.background} !important;
`;

export const AreaForm = Styled.div`

display: flex;
width: 95%;
justify-self:center;
align-self: center;
pointer-events: ${(props)=>props.visible?'none':'auto'};
opacity: ${(props)=>props.visible?'0.15':'1'};
position: ${(props)=>props.visible?'fixed':'relative'};

@media only screen and (max-width: 991px) {
  margin-left: 0 ;

}
`;


export const ContentCard = Styled.div`
display:flex;
flex-direction: column;
animation-duration: 2s;


`;

export const Text = Styled.div`
display:none;
margin-left: 20px;
@media only screen and (max-width:991px){
  display: block;
}
`;
export const Icon = Styled.div`
display:flex;

`;

export const CardMenu = Styled.div`

display:flex;
justify-content: left;
height: 30px;
border: solid rgba(255,255,255,.2);
border-width:  0px 0px 1px 0px;
font-size: ${props => props.theme.fontSize.small};
color: ${props => props.theme.textColors.secundary};
align-items:center;
padding: 5px;
:hover{
  animation-name: 'open';
}




@keyframes open {
  0% {left:0px; height:0px; background: red;}

100% { left:40px; height:30px;}
}
@keyframes closed {
  0% {left:0px; height:30px;}

100% { left:0px; height:0px;}
}

`;



